import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import PropTypes from "prop-types";

function FaturamentoModal({ modalHook, valuesHook, salvaFaturamento, mei }) {
  const { faturamentoModal, setFaturamentoModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Informar faturamento"
      is_open_modal={faturamentoModal}
      set_is_open_modal={setFaturamentoModal}
      size="lg"
      buttons={
        <CommonButton
          key={`upload-imposto`}
          color="success"
          onClick={() => {
            salvaFaturamento();
          }}
        >
          Upload
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-12 mb-3">
          <CommonInput
            label="Mês e ano"
            id="data_faturamento"
            value={values.data_faturamento}
            type="month"
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <h6>{!mei ? "Receita internacional" : "Valor de servico"}</h6>
        <div className="col-md-3 mb-3">
          <CommonInputValor
            label="Notas na Orangiuz"
            id="notas_orangiuz_servico"
            value={values.notas_orangiuz_servico}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className="col-md-1" style={{ textAlign: "center" }}>
          <div className="mb-3">
            <h4 style={{ marginTop: "2rem" }}>+</h4>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputValor
            label="Valor adicional"
            id="valor_servico"
            value={values.valor_servico}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_servico",
                e.target.value,
                values,
                setValues
              );
            }}
          />
        </div>
        <div className="col-md-1" style={{ textAlign: "center" }}>
          <div className="mb-3">
            <h4 style={{ marginTop: "2rem" }}>=</h4>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Total"
            id="total_servico"
            value={values.notas_orangiuz_servico + values.valor_servico || 0}
            onChange={() => {}}
            disabled
          />
        </div>
      </div>
      <div className="row">
        <h6>{!mei ? "Receita nacional" : "Valor de comércio"}</h6>
        <div className="col-md-3 mb-3">
          <CommonInputValor
            label="Notas na Orangiuz"
            id="notas_orangiuz_comercio"
            value={values.notas_orangiuz_comercio}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className="col-md-1" style={{ textAlign: "center" }}>
          <div className="mb-3">
            <h4 style={{ marginTop: "2rem" }}>+</h4>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <CommonInputValor
            label="Valor adicional"
            id="valor_comercio"
            value={values.valor_comercio}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_comercio",
                e.target.value,
                values,
                setValues
              );
            }}
          />
        </div>
        <div className="col-md-1" style={{ textAlign: "center" }}>
          <div className="mb-3">
            <h4 style={{ marginTop: "2rem" }}>=</h4>
          </div>
        </div>
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Total"
            id="total_comercio"
            value={values.notas_orangiuz_comercio + values.valor_comercio || 0}
            onChange={() => {}}
            disabled
          />
        </div>
      </div>
    </CommonModal>
  );
}

FaturamentoModal.propTypes = {
  modalHook: PropTypes.shape({
    faturamentoModal: PropTypes.bool.isRequired,
    setFaturamentoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaFaturamento: PropTypes.func.isRequired,
  mei: PropTypes.bool.isRequired,
};
export default FaturamentoModal;
